<template>
    <el-dialog :title="$t('DetailsOfThirdPartySalesOrder.Sub')" :visible.sync="dialogVisible">
      <el-table :data="tableData" style="width: 100%" border>
          <el-table-column prop="outerOrderNo" :label="$t('BjDialogListConfig.Thirdordernumber')" align="center"> </el-table-column>
      </el-table>
    </el-dialog>
</template>

<script>

export default {
    data() {
      return {
        dialogVisible: false,
        tableData: []
      }
    }
}
</script>